import { Button, Modal, Select } from '@bitcine/cinesend-theme/dist'
import { useQuery } from '@tanstack/react-query'
import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import useStore from '../../hooks/use_store'
import { convertToShorthandWithTimezone } from '../../helpers/convert_date'

function OpenModal({ cycleID, assetID, field, isLoading, value, onClose, saveField, refreshAsset }) {
  const params = useParams()
  const [stateValue, setStateValue] = useState(value)
  const { data, isLoading: isLoadingOptions } = useQuery([
    `media-info-files?assetID=${assetID}&airlineID=${params.airlineID}&fieldID=${field.id}`,
  ])
  const options = data
    ? data.map((option) => ({
        value: option.external_id,
        label: option.file_name, // TODO: display version (received time maybe) of file, should be done with file version check validator
        fileName: option.file_name,
        receivedTime: convertToShorthandWithTimezone(option.file.receivedTime),
      }))
    : []
  const { updateModel, createModel, deleteModel } = useStore()

  useEffect(() => {
    if (data) {
      setStateValue(data.find((opt) => opt.file_name == value)?.external_id)
    }
  }, [data, value])

  const saveFileValue = (newValue) => {
    let data = {
      cycle_id: cycleID,
      asset_id: parseInt(assetID),
      value: newValue,
    }

    if (field.field_type === 'video') {
      saveVideoValue(data)
    } else if (field.field_type === 'audio') {
      saveAudioValue(data)
    } else {
      setMessage('Invalid field type')
    }
  }

  const saveVideoValue = (data) => {
    if (data.value === null) {
      deleteModel.mutate({
        endpoint: 'asset-videos',
        id: field.value.id,
        onSuccess: onSuccessHandler,
        onError: saveField,
      })
    } else if (field.value?.id) {
      updateModel.mutate({
        endpoint: 'asset-videos',
        id: field.value.id,
        data,
        onSuccess: onSuccessHandler,
        onError: saveField,
      })
    } else {
      data.field_id = field.id
      createModel.mutate({ endpoint: 'asset-videos', data, onSuccess: onSuccessHandler, onError: saveField })
    }
  }

  const saveAudioValue = (data) => {
    if (data.value === null) {
      deleteModel.mutate({
        endpoint: 'asset-audios',
        id: `${field.value.id}?cycle_id=${cycleID}`,
        onSuccess: onSuccessHandler,
      })
    } else if (value) {
      updateModel.mutate({ endpoint: 'asset-audios', id: field.value.id, data, onSuccess: onSuccessHandler })
    } else {
      data.field_id = field.id
      createModel.mutate({ endpoint: 'asset-audios', data, onSuccess: onSuccessHandler })
    }
  }

  const onSuccessHandler = (res) => {
    saveField()
    refreshAsset()
  }

  return (
    <Modal
      header={'Select File from External API'}
      onClose={onClose}
      confirmButton={{
        text: 'Save',
        onClick: () => {
          saveFileValue(stateValue)
          onClose()
        },
      }}
    >
      <Select
        label={field.name}
        isLoading={isLoading || isLoadingOptions}
        value={options.find((opt) => opt.value === stateValue)}
        options={options}
        isClearable
        formatOptionLabel={({ fileName, receivedTime, label }, { context }) => {
          if (context === 'menu') {
            return (
              <div className='flex justify-between w-full'>
                <span>{fileName}</span>
                <span className='text-xs text-gray-400'>{receivedTime}</span>
              </div>
            )
          }
          return label
        }}
        isMulti={field.is_multi_select}
        onChange={(opt) => setStateValue(opt ? opt.value : null)}
      />
    </Modal>
  )
}

export default function FileSelector({ cycleID, assetID, field, value, isLoading, saveField, refreshAsset }) {
  const [modalOpen, setModalOpen] = useState(false)

  return (
    <div>
      <Button className='min-w-40' secondary onClick={() => setModalOpen(true)}>
        Select File
      </Button>
      {modalOpen && (
        <OpenModal
          cycleID={cycleID}
          assetID={assetID}
          field={field}
          value={value}
          isLoading={isLoading}
          saveField={saveField}
          refreshAsset={refreshAsset}
          onClose={() => setModalOpen(false)}
        />
      )}
    </div>
  )
}
